/* ============================================================================
 * NRN PRICE GUARD — der Preis darf beim Variantenwechsel NIE verschwinden
 * ----------------------------------------------------------------------------
 * URSACHE des Bugs:
 * Auf der Produktseite gibt es zwei Preis-Slots (Dawn-Standard):
 *   .price__regular  -> sichtbar wenn KEIN Sale
 *   .price__sale     -> sichtbar wenn Sale (.price--on-sale)
 * Mehrere Skripte im Theme setzen auf diesen beiden Slots INLINE
 * "display:none !important":
 *   - nrn-price-sync.js (updateFromVariant)
 *   - der nrnKillStray-Inline-Block in main-product.liquid
 *   - der Sale-Badge-Block aus templates/product.json
 * Wenn eine Variante mit ANDEREM Preis gewaehlt wird und der Wechsel ueber
 * einen anderen Pfad laeuft (Section-Rendering statt updateFromVariant),
 * bleibt das alte inline display:none auf dem jetzt benoetigten Slot stehen —
 * beide Slots sind versteckt und die Preiszeile zeigt nur noch Streichpreis
 * und "Save x%", aber keinen Preis mehr.
 *
 * FIX (bewusst simpel und damit zuverlaessig):
 * Nach jedem Variantenwechsel bzw. jeder Aenderung an der Preisbox wird
 * geprueft, welcher Slot tatsaechlich einen Betrag enthaelt, und genau dieser
 * wird sichtbar gemacht. Ist der eigentlich zustaendige Slot leer, wird der
 * Betrag aus dem anderen Slot uebernommen. So ist IMMER genau ein Preis
 * sichtbar — egal welches andere Skript vorher was versteckt hat.
 * ==========================================================================*/
(function () {
  'use strict';

  var HAS_DIGIT = /\d/;
  var busy = false;

  function moneyEl(slot) {
    if (!slot) return null;
    var pref = slot.querySelectorAll(
      '.price-item--last, .price-item--sale, .price-item--regular, .price-item'
    );
    for (var i = 0; i < pref.length; i++) {
      if (HAS_DIGIT.test(pref[i].textContent || '')) return pref[i];
    }
    /* Fallback: erstes Blatt-Element mit Ziffern (ohne Screenreader-Text) */
    var all = slot.querySelectorAll('span, div, strong, s');
    for (var j = 0; j < all.length; j++) {
      if (all[j].classList.contains('visually-hidden')) continue;
      if (!all[j].children.length && HAS_DIGIT.test(all[j].textContent || '')) return all[j];
    }
    return null;
  }

  function firstMoneyTarget(slot) {
    if (!slot) return null;
    return slot.querySelector('.price-item--sale, .price-item--last, .price-item--regular, .price-item');
  }

  function show(el, mode) {
    if (!el) return;
    el.style.setProperty('display', mode, 'important');
    el.style.setProperty('visibility', 'visible', 'important');
    if (el.style.opacity === '0') el.style.removeProperty('opacity');
  }

  function hide(el) {
    if (!el) return;
    el.style.setProperty('display', 'none', 'important');
  }

  function fixOne(priceEl) {
    if (!priceEl) return;

    var reg  = priceEl.querySelector('.price__regular');
    var sale = priceEl.querySelector('.price__sale');
    if (!reg && !sale) return;

    var regMoney  = moneyEl(reg);
    var saleMoney = moneyEl(sale);

    /* Leerer Slot? Betrag aus dem anderen Slot uebernehmen, damit beide
       Slots jederzeit einen gueltigen Preis enthalten. */
    if (!regMoney && saleMoney) {
      var regTarget = firstMoneyTarget(reg);
      if (regTarget) { regTarget.textContent = saleMoney.textContent; regMoney = regTarget; }
    } else if (!saleMoney && regMoney) {
      var saleTarget = firstMoneyTarget(sale);
      if (saleTarget) { saleTarget.textContent = regMoney.textContent; saleMoney = saleTarget; }
    }

    if (!regMoney && !saleMoney) return;   /* nichts zu retten (z.B. Platzhalter) */

    var onSale = priceEl.classList.contains('price--on-sale');

    /* Der zustaendige Slot gewinnt — hat er keinen Betrag, springt der
       andere ein, damit nie eine leere Preiszeile stehenbleibt. */
    var useSale = onSale ? !!saleMoney : !regMoney;

    if (useSale) {
      show(sale, 'flex');
      sale.style.setProperty('flex-direction', 'row', 'important');
      sale.style.setProperty('align-items', 'baseline', 'important');
      hide(reg);
    } else {
      show(reg, 'block');
      hide(sale);
    }
  }

  function run() {
    if (busy) return;
    busy = true;
    try {
      var wraps = document.querySelectorAll(
        '.price-wrap-custom .price, .product__info-container .price, ' +
        '[id^="price-"] .price, .sticky-atc .price, .nrn-sticky-atc .price'
      );
      for (var i = 0; i < wraps.length; i++) fixOne(wraps[i]);
    } catch (e) { /* niemals die Seite blockieren */ }
    /* erst im naechsten Frame freigeben, damit die eigenen DOM-Aenderungen
       den MutationObserver nicht in eine Schleife schicken */
    requestAnimationFrame(function () { busy = false; });
  }

  function runSoon() {
    run();
    setTimeout(run, 60);
    setTimeout(run, 220);
    setTimeout(run, 600);
  }

  run();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', runSoon, { once: true });
  } else {
    runSoon();
  }
  window.addEventListener('load', runSoon, { once: true });

  /* Variantenwechsel — beide Event-Wege, die das Theme benutzt */
  document.addEventListener('variant:change', runSoon);
  document.addEventListener('change', function (e) {
    if (e.target && e.target.closest &&
        e.target.closest('variant-selects, variant-radios, .product-form__input, .nrn-ws')) {
      runSoon();
    }
  }, true);
  document.addEventListener('click', function (e) {
    if (e.target && e.target.closest &&
        e.target.closest('variant-selects, variant-radios, .product-form__input, .nrn-ws, .nrn-opt')) {
      runSoon();
    }
  }, true);

  if (window.MutationObserver) {
    var mo = new MutationObserver(function () {
      if (busy) return;
      requestAnimationFrame(run);
    });
    var attach = function () {
      var host = document.querySelector('.product__info-container') ||
                 document.querySelector('.product__info-wrapper');
      if (host) {
        mo.observe(host, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['class', 'style'] });
      }
    };
    attach();
    document.addEventListener('DOMContentLoaded', attach);
    setTimeout(attach, 800);
  }
})();
